import styled from "styled-components"
import { MainFrame, MainHeadingCapital, MainText } from "../../../components/01_config/MainStyles"
import { colors } from "../../../components/01_config/Colors"
import { sizes } from "../../../components/01_config/Sizes"

const FrameContent = styled(MainFrame)`
    width: 600px;
    flex-direction: column;
    gap: 30px;
    margin: ${sizes.sections_gap_desk} auto;
    align-items: start;
`

const FrameHeading = styled(MainHeadingCapital)`
    margin: 0 auto;
    color: ${colors.myprogress};
    color: #044AEF;
    font-weight: bold;
    font-size: 1.4rem;
`

const Lesson = styled.div`
    font-weight: 600;
`

const Text = styled(MainText)`
    width: 100%;
    white-space: pre-wrap;
    text-align: center;
    cursor: pointer;
    &:hover {
        color: ${colors.headingColor};
    };
        &:active {
        background-color: lightblue;
    }
`

export { FrameContent, FrameHeading, Lesson, Text }